<template>
  <div class="share-earn-money" v-if="showShareEarn">
    <div class="spu-earn" v-if="showSpuShareEarnInfo">
      <div class="spu-earn-icon">赚</div>
      <!-- 分享赚最大金额与最小金额不等，展示区间 -->
      <div
        class="spu-earn-money pf-medium"
        v-if="
          shareSaleAmountVo.minShareAmount !== shareSaleAmountVo.maxShareAmount
        "
      >
        {{ shareSaleAmountVo.minShareAmount / 100 }}-{{
          shareSaleAmountVo.maxShareAmount / 100
        }}元
      </div>
      <!-- 分享赚最大金额与最小金额相等，展示最大金额 -->
      <div class="spu-earn-money pf-medium" v-else>
        <span>{{ shareSaleAmountVo.maxShareAmount / 100 }}元</span>
      </div>
    </div>
    <div class="spu-earn" v-if="showSkuShareEarnInfo">
      <div class="spu-earn-icon">赚</div>
      <div class="spu-earn-money pf-medium">
        {{ singleSkuShareEarnInfo / 100 }}元
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { showShareEarnInProductDetail } from '@/router/home/utils'
export default {
  components: {},
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {
    ...mapState(['product', 'selectedSku']),
    showShareEarn() {
      return showShareEarnInProductDetail()
    },
    shareSaleAmountVo() {
      return this.product.shareSaleAmountVo
    },
    showSpuShareEarnInfo() {
      /* 是否显示商品级分享赚金额信息
         this.shareSaleAmountVo 判断是否有分享赚信息 人客端且设置分享赚会返回
         this.shareSaleAmountVo.maxShareAmount 分享赚最高金额为0 不展示分享赚信息 */
      return (
        this.shareSaleAmountVo &&
        !this.selectedSku?.skuId &&
        this.shareSaleAmountVo.maxShareAmount !== 0
      )
    },
    showSkuShareEarnInfo() {
      /* 是否显示商品规格级分享赚金额信息
         this.shareSaleAmountVo 判断是否有分享赚信息 人客端且设置分享赚会返回
         this.shareSaleAmountVo.skuIdsRateMap 有商品规格分享赚信息
         this.singleSkuShareEarnInfo !== 0 规格分享赚金额为0 不展示分享赚信息 */
      return (
        this.shareSaleAmountVo &&
        this.selectedSku?.skuId &&
        this.shareSaleAmountVo.skuIdsRateMap &&
        this.singleSkuShareEarnInfo !== 0
      )
    },
    singleSkuShareEarnInfo() {
      // 商品单个规格分享赚金额信息
      return this.shareSaleAmountVo?.skuIdsRateMap[this.selectedSku?.skuId] || 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.spu-earn {
  display: flex;
  align-items: center;
  border: rem(2px) #ff5900 solid;
  border-radius: rem(30px);
  overflow: hidden;
  margin-left: rem(20px);
  .spu-earn-icon {
    height: rem(36px);
    line-height: rem(36px);
    padding-left: rem(36px);
    padding-right: rem(4px);
    color: #ffffff;
    font-size: rem(22px);
    background: url('~@/assets/images/icon-money.png') rem(12px) center/
      rem(24px) rem(28px) no-repeat;
    background-color: #ff7615;
    border-top-left-radius: rem(30px);
    border-bottom-left-radius: rem(30px);
  }
  .spu-earn-money {
    height: rem(36px);
    background-color: #fff9ed;
    line-height: rem(36px);
    padding-left: rem(4px);
    padding-right: rem(12px);
    font-size: rem(22px);
    color: #ff5900;
    @include ellicpsis;
  }
}
</style>
